const TEXT = {
    SHOW_MORE_POINTS: "Se flere",
    SHOW_LESS_POINTS: "Se færre",
} as const;

export default TEXT;
